import { css } from '@emotion/core';
import { applyFont, tokens } from '@domain-group/fe-brary';
var colors = tokens.colors,
  typography = tokens.typography;
export var primaryFeature = {
  name: "1u8h5t9",
  styles: "display:flex;flex-direction:row;gap:24px;"
};
export var iconWrapper = /*#__PURE__*/css("width:48px;height:48px;border-radius:100px;padding:12px;background-color:", colors.interactive.base.default, ";");
export var icon = /*#__PURE__*/css("vertical-align:unset;color:", colors.neutral.surface.default, ";");
export var details = {
  name: "1kkt86i",
  styles: "display:flex;flex-direction:column;gap:4px;"
};
export var title = /*#__PURE__*/css(applyFont(typography.subheading), " color:", colors.neutral.heavy.default);
export var description = /*#__PURE__*/css(applyFont(typography.body), " color:", colors.neutral.medium.default);